import React, { useEffect, useContext, useState, useRef } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { v4 as uuidv4 } from 'uuid';

import { useNavigate } from 'react-router-dom';

import {
  Box,
  Popover,
} from '@mui/material';

import moreForAdmin from '../../../../images/moreForAdmin.svg'
import addForAdmin from '../../../../images/addForAdmin.svg'
import dragForAdmin from '../../../../images/dragForAdmin.svg'

import APIS from "../../../../utils/APIS"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"
import PopupNotifContext from "../../../../contexts/PopupNotifContext"

import SideBarSequence from "./SideBarSequence"

const SideBarPartie = ({ content, updateContent, chapId, partId, iChap, iPart, actIndex, setIndex }) => {

  const { addPartie, deletePartie, duplicatePartie } = useContext(SuperAdminContext)
  const { addPopupNotif } = useContext(PopupNotifContext)

  const popoverRef = useRef()

  const [isOpen, setIsOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const [title, setTitle] = useState("")

  useEffect(() => {
    setTitle(content?.chapitre[iChap]?.partie[iPart]?.title)

    if (iChap === actIndex?.chapitre && iPart === actIndex?.partie) {
      setIsOpen(true)
    }
  }, [])

  return (
    <Draggable
      key={'key_plan_chap_card_' + partId + '_' + chapId}
      draggableId={'drag_part_id_' + partId}
      index={iPart}
    >
      {(provided, snapshot) => (
        <>
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}
            key={'plan_chap_card_' + partId + '_' + chapId}

          >
            <Box sx={{
              height:"30px",
              display:"flex",
              padding:"10px",
              alignItems:"center",
              justifyContent:"flex-start",
              overflow:"hidden",
              position:"relative",
              "&:hover" : {
                ".viewOnHover" : {
                  opacity:"1 !important",
                }
              },
              "::after" : {
                content : '""',
                position:"absolute",
                width:"210px",
                height:"1px",
                background:"#2929292f",
                top:0,
                left:"30px",
              },
            }}>
              <Box {...provided.dragHandleProps} sx={{
                width:"30px",
                opacity:0.5,
              }}>
                <img src={dragForAdmin} className="viewOnHover" style={{width:"16px", opacity:0, marginLeft:"6px"}} />
              </Box>

              <Box sx={{
                flex:1,
                display:"flex",
                gap:"10px",
                alignItems:"center",
                overflow:"hidden",
              }}>
                <Box
                  onClick={(e) => {
                    setIsOpen(!isOpen)
                  }}
                  sx={{
                    cursor:"pointer",
                    transform:!isOpen&&"rotate(-90deg)",
                    userSelect:"none",
                  }}
                >
                  ▼
                </Box>
                <Box sx={{
                  fontSize:"14px",
                  color:"orange"
                }}>{iPart + 1}.</Box>
                <Box
                  contentEditable="true"
                  suppressContentEditableWarning={true}
                  sx={{
                    fontWeight:"bold",
                    fontSize:"14px",
                    /* ⚠️ 2px NE SUFFIT PAS DEPUIS QUE LE TITRE PEUT ETRE VIDE.
                       La creation ne seme plus « Modifier le titre » (19/09) :
                       un sous-chapitre neuf arrive donc sans titre, et une zone
                       editable de 2 px est en pratique incliquable. On lui donne
                       une cible. Ce n'est pas un systeme de placeholder — aucun
                       texte n'est affiche, ni stocke. */
                    minWidth:"90px",
                    whiteSpace:"noWrap",
                    overflow:"hidden"
                  }}
                  onClick={(e) => {e.stopPropagation()}}
                  onBlur={(e) => {
                    setTitle(e?.target?.textContent)
                  }}
                  onInput={(e) => {
                    let newFormation = JSON.parse(JSON.stringify(content))
                    newFormation.chapitre[iChap].partie[iPart].title = e?.target?.textContent
                    updateContent(newFormation)
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    var text = '';
                    if (e.clipboardData || e.originalEvent.clipboardData) {
                      text = (e.originalEvent || e).clipboardData.getData('text/plain');
                    } else if (window.clipboardData) {
                      text = window.clipboardData.getData('Text');
                    }
                    if (document.queryCommandSupported('insertText')) {
                      document.execCommand('insertText', false, text);
                    } else {
                      document.execCommand('paste', false, text);
                    }
                  }}
                >
                  {title}
                </Box>
              </Box>
              <Box
                ref={popoverRef}
                sx={{flexShrink:0, opacity:1, cursor:"pointer", userSelect:"none", marginLeft:"5px"}}
                onClick={(e) => {
                  e.stopPropagation()
                  setMenuOpen(!menuOpen)
                }}
              >
                {menuOpen ? (
                  <img src={addForAdmin} style={{width:"16px", transform:"rotate(45deg)"}} />
                ) : (
                  <img src={moreForAdmin} className="viewOnHover" style={{width:"16px", opacity:0}} />
                )}
                <Popover
                  open={menuOpen}
                  anchorEl={popoverRef?.current}
                  onClose={() => setMenuOpen(false)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Box sx={{
                    userSelect:"none",
                    padding:"0px 5px",
                    color:"black",
                  }}>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => { deletePartie({ iChap: iChap, iPart: iPart }) }}
                    >
                      Supprimer
                    </Box>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => { duplicatePartie({ iChap: iChap, iPart: iPart }) }}
                    >
                      Dupliquer
                    </Box>
                    <Box
                      sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                      onClick={() => {
                        let partie = JSON.stringify(content?.chapitre[iChap]?.partie[iPart])
                        localStorage.setItem('copyPasteFormation', JSON.stringify({type:"formationPart", partie : partie}));
                        addPopupNotif({
                          uuid : uuidv4(),
                          title : "Partie copiée",
                          type : "confirm",
                          removeAfter:3000,
                        })
                      }}
                    >
                      Copier
                    </Box>
                    <Box
                      sx={{padding:"10px", cursor:"pointer"}}
                      onClick={() => {
                        let infos = JSON.parse(localStorage.getItem('copyPasteFormation'))
                        if (infos && infos?.partie && infos?.type === "formationPart") {
                          let newPartie = JSON.parse(infos?.partie)
                          addPartie({ iChap: iChap, iPart: iPart + 1, iSeq: 0 },  newPartie)
                        } else {
                          addPopupNotif({
                            uuid : uuidv4(),
                            title : "Aucune données",
                            type : "error",
                            removeAfter:3000,
                          })
                        }
                      }}
                    >
                      Coller (après)
                    </Box>
                  </Box>
                </Popover>
              </Box>
            </Box>

            {isOpen &&
              <Box sx={{marginBottom:"10px"}}>
                <Droppable
                  key={'key_plan_chap_droppable_' + chapId + '_' +partId}
                  droppableId={partId + '_droppableSequences'}
                  type={`droppableSequences`}
                >
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef}>
                      {content?.chapitre[iChap]?.partie[iPart]?.sequence?.map((sequence, iSeq) => {
                        return (
                          <SideBarSequence
                            content={content}
                            updateContent={updateContent}
                            iPart={iPart}
                            iChap={iChap}
                            iSeq={iSeq}
                            seqId={sequence?.id}
                            partId={partId}
                            chapId={chapId}
                            key={'key_plan_format_' + chapId + '_' + partId + '_' + sequence?.id}
                            actIndex={actIndex}
                            setIndex={setIndex}
                          />
                        )
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </Box>
            }
          </Box>


        </>
      )}
    </Draggable>
  )
};

export default SideBarPartie;
